











import { Component, Prop } from 'vue-property-decorator';
import { VehicleStateItem } from '@/core/interfaces/vehicleState';
import { mixins } from 'vue-class-component';
import UsesTranslatableValue from '@/components/mixins/UsesTranslatableValue';
import SvgIcon from '@/components/SvgIcon.vue';

@Component({
    components: { SvgIcon },
})
export default class VehicleStateFactItem extends mixins(UsesTranslatableValue) {
  @Prop({ required: true })
  item!: VehicleStateItem;
}

